// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__1Q3YH","addWidgetButton":"Header_addWidgetButton__hHB-p","dashboardTabs":"Header_dashboardTabs__3oSep","active":"Header_active__2eNp6"};